import { useEffect, useState } from 'react'
import SendBird, { SendBirdInstance } from 'sendbird'

export default (appId: string | undefined) => {
  const [sendBirdInstance, setSendBirdInstance] = useState<SendBirdInstance | undefined>(undefined)

  useEffect(() => {
    if (appId && appId.length) {
      setSendBirdInstance(new SendBird({ appId }))
    } else if (sendBirdInstance) {
      // teardown due to appId dissappearing (will likely never happen).
      setSendBirdInstance(undefined)
    }
  }, [appId])

  return sendBirdInstance
}
